/* eslint-disable @typescript-eslint/no-unsafe-return */
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { openThirdPage } from '@/api/native/utils';
import { ContractData } from '@/api/contract/types';
import type { IBankData } from '@/api/quick-bind-card/types';
import { commodityContractList } from '@/api/quick-bind-card';
import { contractsUrl } from '@/constant';

import style from './index.module.scss';

const PopupSlide = () => import(
  /* webpackChunkName: "popup-slide" */'@/components/popup-slide'
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) as any;

@Component
export class AgreeProtocolDialog extends Vue {
  @Prop(Boolean) readonly visible!: boolean;

  @Prop(Object) readonly bankData!: IBankData;

  @Prop(String) readonly capitalCode!: string;

  @Prop(String) readonly productId!: string;

  private contractList: ContractData[] = [];

  private get cardTypes(): string[] {
    return ['储蓄卡'];
  }

  private onCloseDialog() {
    this.$emit('cancel');
  }

  private onAgreeProtocol() {
    this.$emit('confirm');
  }

  private seeProtocol({ url }: ContractData) {
    const finalUrl = /pdf/g.test(url) ? `${contractsUrl}?pdf_url=${url}` : url;
    // 目前只在app环境中开放入口，不需要处理外跳后页面刷新问题，后续开放其他环境后需要注意处理
    openThirdPage(finalUrl);
  }

  @Watch('visible', { immediate: true })
  private updateContractList(visible: boolean): void {
    if (this.bankData && visible) {
      this.commodityContractList();
    }
  }

  private async commodityContractList() {
    const list = await commodityContractList({
      bankCode: this.bankData.bankCode || '',
      commodityId: Number(this.productId),
      capitalCode: this.capitalCode,
    });

    if (list && list.length > 0) {
      this.contractList = list;
    }
  }

  private renderContract() {
    return (
      <p class={style.contractText}>
        {
          this.contractList.map(
            (item) => <span onClick={() => this.seeProtocol(item)}>{item.name}</span>,
          )
        }
      </p>
    );
  }

  private renderCardType() {
    const { bankLogo = '', bankName = '' } = this.bankData || {};

    return (
      <div class={style.cardTypeBox}>
        {this.cardTypes.map((typeName) => <p class={style.cardType}>
          <span class={style.icon} style={{ backgroundImage: `url(${bankLogo})` }} />
          <span class={style.name}>{`${bankName} ${typeName}`}</span>
          <span class={style.checked}/>
        </p>)}
      </div>
    );
  }

  private render() {
    return (
      <PopupSlide
        v-model={this.visible}
        class={style.agreeProtocolDialog}
        popPostion="center"
        confirmText="同意协议并添加"
        popTitle="请选择银行卡类型"
        titlePostion="center"
        onConfirm={() => this.onAgreeProtocol()}
        onClose={() => this.onCloseDialog()}
      >
        <div slot="popupContent" class={style.agreeProtocol}>
          {this.renderCardType()}
          <div class={style.contractBox}>
            添加银行卡需同意{this.renderContract()}
          </div>
        </div>
      </PopupSlide>
    );
  }
}
